import ReferencedContent from './ReferencedContent';
import { register } from '../ZNode';

register('FixedTextContent', ReferencedContent);
export default ReferencedContent;
